import { render } from "./RedactoresComponent.vue?vue&type=template&id=1efe3c73&scoped=true"
import script from "./RedactoresComponent.vue?vue&type=script&lang=js"
export * from "./RedactoresComponent.vue?vue&type=script&lang=js"

import "./RedactoresComponent.vue?vue&type=style&index=0&id=1efe3c73&scoped=true&lang=css"

import exportComponent from "/Users/norberto/Documents/Marketing HL/adminmkthl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1efe3c73"]])

export default __exports__